import { render, staticRenderFns } from "./Influencia.vue?vue&type=template&id=983d9a3c&scoped=true"
import script from "./Influencia.vue?vue&type=script&setup=true&lang=js"
export * from "./Influencia.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Influencia.vue?vue&type=style&index=0&id=983d9a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983d9a3c",
  null
  
)

export default component.exports